package nl.astraeus.midi.symbols

import nl.astraeus.midi.NoteLength
import org.w3c.dom.HTMLCanvasElement

fun createNoteUp(length: NoteLength): HTMLCanvasElement {
  val (canvas, ctx) = createCanvasCtx()

  val centerX = 49.5
  val centerY = 150.0

  val dx = if (length != NoteLength.HALF) {
    -0.0
  } else {
    -0.0
  }

  ctx.drawBravura(length.glyph, centerX + dx, centerY)

  if (length != NoteLength.WHOLE) {
    ctx.beginPath()
    ctx.moveTo(76.5, 96.5)
    ctx.lineTo(76.5, 10.5)
    ctx.stroke()
    ctx.closePath()
  }

  if (length == NoteLength.EIGHTEENTH) {
    ctx.drawBravura("\ue240", 25.0, 50.0)
  }

  return canvas
}

fun createNoteDown(length: NoteLength): HTMLCanvasElement {
  val (canvas, ctx) = createCanvasCtx()

  val centerX = 49.8
  val centerY = 150.0

  val dx = if (length != NoteLength.HALF) {
    -0.0
  } else {
    -0.0
  }

  ctx.drawBravura(length.glyph, centerX + dx, centerY)

  if (length != NoteLength.WHOLE) {
    ctx.beginPath()
    ctx.moveTo(51.5, 102.5)
    ctx.lineTo(51.5, 102.5 + 86.5)
    ctx.stroke()
    ctx.closePath()
  }

  if (length == NoteLength.EIGHTEENTH) {
    ctx.drawBravura("\ue240", 25.0, 50.0)
  }

  return canvas
}
